export default "__VITE_ASSET__2f4b6411__"